import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import type { CrmSection } from "@/lib/api";

interface ProtectedRouteProps {
  children: React.ReactNode;
  section?: CrmSection;
}

const sectionPath: Record<CrmSection, string> = {
  catalog: "/catalog",
  orders: "/orders",
  requests: "/requests",
  analytics: "/analytics",
  users: "/users",
};

export default function ProtectedRoute({ children, section }: ProtectedRouteProps) {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  if (section && !user?.permissions.includes(section)) {
    const fallback = user?.permissions[0] ? sectionPath[user.permissions[0]] : "/login";
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}
